import { queryOptions } from "@tanstack/react-query";
import type { PublicTestimonial, TestimonialPlacement } from "@/types/testimonials";
import { apiUrl } from "@/lib/api-url";

export interface HomepageTestimonialsEnvelope {
  testimonials: PublicTestimonial[];
}

/**
 * SSR-safe public query for the curated testimonials of one placement
 * ("home" = homepage marquee, "therapists" = /za-terapeute carousel).
 * apiUrl() resolves to loopback server-side (a bare relative fetch throws under
 * Bun); the placement is part of the key so SSR invalidation only drops the
 * pages that actually render it.
 */
export function testimonialsQuery(placement: TestimonialPlacement) {
  return queryOptions({
    queryKey: ["homepage-testimonials", "public", placement] as const,
    queryFn: async (): Promise<HomepageTestimonialsEnvelope> => {
      const res = await fetch(apiUrl(`/api/homepage-testimonials?placement=${placement}`));
      if (!res.ok) throw new Error("Failed to fetch testimonials");
      return res.json();
    },
  });
}

export const homepageTestimonialsQuery = testimonialsQuery("home");
export const therapistTestimonialsQuery = testimonialsQuery("therapists");
